// extracted by mini-css-extract-plugin
export default {"subscribeBtn":"SubscribeButton_subscribeBtn__4MZJP"};